import { Location } from '@app/shared/routes';

const LoginLocation = new Location({ path: '/login' });

export { LoginLocation };
